import { render } from "./ForgetView.vue?vue&type=template&id=22e33e74&scoped=true"
import script from "./ForgetView.vue?vue&type=script&lang=js"
export * from "./ForgetView.vue?vue&type=script&lang=js"

import "./ForgetView.vue?vue&type=style&index=0&id=22e33e74&lang=less&scoped=true"

import exportComponent from "../../../firstwindow_xz_vue/node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e33e74"]])

export default __exports__